export const SET_SUPPLIER_LOADING = 'SUPPLIER_REGISTRATION/SET_SUPPLIER_LOADING';
export const SET_SUPPLIER = 'SUPPLIER_REGISTRATION/SET_SUPPLIER';
export const SET_SUPPLIERS = 'SUPPLIER_REGISTRATION/SET_SUPPLIERS';
export const SET_SUPPLIER_UUID = 'SUPPLIER_REGISTRATION/SET_SUPPLIER_UUID';
export const SET_SUPPLIER_ERRORS = 'SUPPLIER_REGISTRATION/SET_SUPPLIER_ERRORS';
export const CLEAR_SUPPLIER_ERRORS = 'SUPPLIER_REGISTRATION/CLEAR_SUPPLIER_ERRORS';
export const CLEAR_SUPPLIER = 'SUPPLIER_REGISTRATION/CLEAR_SUPPLIER';